import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Armchair, Gauge, Package, Handshake, MapTrifold } from '@phosphor-icons/react';
import { ModuleSidebar } from '@/components/enterprise/ModuleSidebar';
import { bihinApi } from './bihinApi';

const SECTIONS = [
  {
    items: [
      { to: '/bihin', end: true, label: 'ダッシュボード', icon: Gauge, testid: 'bihin-nav-dashboard' },
      { to: '/bihin/items', label: '備品一覧', icon: Package, testid: 'bihin-nav-items' },
      { to: '/bihin/loans', label: '貸出', icon: Handshake, testid: 'bihin-nav-loans' },
      { to: '/bihin/floormap', label: 'フロアマップ', icon: MapTrifold, testid: 'bihin-nav-floormap' },
    ],
  },
];

export default function BihinLayout() {
  const [access, setAccess] = useState({ can_edit: false, is_admin: false });
  useEffect(() => { bihinApi.access().then(setAccess).catch(() => {}); }, []);

  return (
    <div className="flex flex-col md:flex-row gap-5 md:gap-6" data-testid="bihin-layout">
      <ModuleSidebar
        icon={Armchair}
        title="備品管理"
        subtitle={undefined}
        sections={SECTIONS}
        testid="bihin-sidebar"
      />
      <main className="flex-1 min-w-0">
        <Outlet context={{ access }} />
      </main>
    </div>
  );
}
